module.exports = __webpack_public_path__ + "img/canada-transport-accidents-male.673873ca.png";